import { BrandLogo } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const Logo = () => {
  return (
    <>
      <Link href="/">
        <Image
          className="logo"
          src={BrandLogo}
          alt="logo"
        />
      </Link>
    </>
  );
};

export default Logo;